import {
  GraphQLInputObjectType,
  GraphQLNonNull,
  GraphQLEnumType
} from 'graphql'
import { orderDirection, OrderDirection } from './order-direction'

export type AttackEventOrderField =
  | 'NAME'
  | 'SOURCE_IP'
  | 'TYPE'
  | 'TIME'
  | 'URI'
  | 'RULE_NAME'
  | 'SOURCE_NAME'

export const attackEventOrderFieldType = new GraphQLEnumType({
  name: 'AttackEventOrderField',
  description: 'Directions to sort a list of attacck events',
  values: {
    SOURCE_NAME: {
      description: 'Order attack events by source name'
    },
    NAME: {
      description: 'Order attack events by name'
    },
    SOURCE_IP: {
      description: 'Order attack events by source IP'
    },
    TYPE: {
      description: 'Order attack events by type'
    },
    TIME: {
      description: 'Order attack events by timestamp'
    },
    URI: {
      description: 'Order attack events by URI'
    },
    RULE_NAME: {
      description: 'Order attack events by rule name'
    }
  }
})

export interface AttackEventOrder {
  readonly field: AttackEventOrderField
  readonly direction: OrderDirection
}

export const attackEventOrderType = new GraphQLInputObjectType({
  name: 'AttackEventOrder',
  description: 'Ways in which a list of attack events can be ordered',
  fields: () => ({
    field: {
      description: 'The field to order the results by',
      type: new GraphQLNonNull(attackEventOrderFieldType)
    },
    direction: {
      description: 'The direction in which to order the results',
      type: new GraphQLNonNull(orderDirection)
    }
  })
})
